<template>
	<div class="main">
		<footer>
			<div class="footer_left">
				<img :src="gameData.logoImage" alt="">
				<p>{{gameData.footer}}</p>
				<p>Trademarks belong to their respective owners. All rights reserved.</p>
				<p v-if="gameData.gameCode === 'fzsgkr'">연락처：chenqiyi@wanxinbuzhi.com</p>
			</div>
			<div class="footer_right">
				<a style="color:#BFBFBF;" v-on:click="openRouteInNewWindow('archive')">{{ $t('service_terms_text') }}</a>
				<span style="color:#BFBFBF;">&nbsp;|&nbsp;</span>
				<a style="color:#BFBFBF;" v-on:click="openRouteInNewWindow('privacy')">{{ $t('privacy_policy_text') }}</a>
			</div>
		</footer>
	</div>
</template>
<script>
export default {
	name: 'AppFooter',
	data() {
		return {
			gameData: this.$store.state.gameData
		}
	},
	methods: {
		openRouteInNewWindow: function (routeName) {
			if (this.gameData.gameCode === 'sgyjltw') {
				const externalRoutes = {
					archive: 'https://member.dustyx.com/archive/homer_archive.html',
					privacy: 'https://member.dustyx.com/privacy/homer_privacy.html'
				};
				window.open(externalRoutes[routeName], '_blank');
				return;
			}

			const routeData = this.$router.resolve({
				name: routeName
			});
			window.open(routeData.href, '_blank');
		}
	}
}
</script>

<style></style>
